import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import events from '4ff-lib-foundation/lib/components/utils/events';
import {
  Filter,
  FilterItems,
  FilterLink,
  Arrows,
  Lshevron,
  Rshevron,
} from './styles';

class FilterPanel extends PureComponent {
  static propTypes = {
    activeSectionID: PropTypes.oneOfType([ // eslint-disable-line
      PropTypes.string,
      PropTypes.number,
    ]),
    onItemClick: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    sections: PropTypes.array, // eslint-disable-line
  };

  state = {
    isRenderArrows: false,
  };

  componentDidMount() {
    events.on(window, 'resize', this.shouldRenderArrows);
    this.shouldRenderArrows();
  }

  componentWillUnmount() {
    events.off(window, 'resize', this.shouldRenderArrows);
  }

  getElementWidth = (el) => {
    const style = window.getComputedStyle ? getComputedStyle(el, null) : el.currentStyle;
    const marginLeft = parseInt(style.marginLeft, 10) || 0;
    const marginRight = parseInt(style.marginRight, 10) || 0;
    return el.offsetWidth + marginLeft + marginRight;
  };

  getItemsWidth = (items) => {
    let resultWidth = 0;
    for (let i = 0; i < items.length; i++) { // eslint-disable-line
      resultWidth += this.getElementWidth(items[i]);
    }
    return resultWidth;
  };

  shouldRenderArrows = () => {
    if (this.itemsContainer.clientWidth < this.getItemsWidth(this.itemsContainer.children)) {
      this.setState({ isRenderArrows: true });
    } else {
      this.setState({ isRenderArrows: false });
    }
  };

  scrollFilterItems = (factor) => {
    this.itemsContainer.scrollLeft += factor * this.itemsContainer.clientWidth;
  };

  scrollLeft = () => {
    this.scrollFilterItems(-1);
  };

  scrollRight = () => {
    this.scrollFilterItems(+1);
  };

  renderArrows = () => (
    <Arrows>
      <Lshevron
        onClick={this.scrollLeft}
        width={22}
        height={22}
      />
      <Rshevron
        onClick={this.scrollRight}
        width={22}
        height={22}
      />
    </Arrows>
  );

  render() {
    return (
      <Filter>
        <FilterItems
          ref={(node) => { this.itemsContainer = node; }}
          withArrows={this.state.isRenderArrows}
        >
          {this.props.sections?.length > 1 && (
            <FilterLink
              active={!this.props.activeSectionID}
              onClick={this.props.onItemClick(null)}
            >
              {this.props.t('LPBD.filter.all')}
            </FilterLink>
          )}
          {this.props.sections && this.props.sections
            .filter(section => !section.meta || (section.meta && !section.meta.lpbDashboardHide))
            .map(section => (
              <FilterLink
                key={section.id}
                active={section.id === this.props.activeSectionID
                  || this.props.sections.length === 1}
                onClick={this.props.onItemClick(section.id)}
              >
                {section.label}
              </FilterLink>
            ))}
        </FilterItems>
        {this.state.isRenderArrows && this.renderArrows()}
      </Filter>
    );
  }
}

export default withTranslation()(FilterPanel);
